import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { View } from '../../../../../../components/Common/react-native-components';
import Table from '../../../../../../components/Common/Table';
import GraphTable from '../../../../../../components/Common/GraphTable';
import Highcharts from 'highcharts';
import {
  convertCstDataIntoBarChartCompatible,
  convertCstDataIntoTableCompatible,
  convertCstDataIntoTableCompatibleTest,
  getMonthWithValues
} from '../../../../../../utils/transformChartsAndTableData';
import HighchartsReact from 'highcharts-react-official';
import GenericNoData from '../../../../../../components/Common/NoData/GenricNoData';
import { handleHighChartsExport } from '../../../MultiSeriesLineChart/utils';
import { Dropdown, Typography } from '@hmsexp/component-library';
import { dropdownStyling } from '../../styles';
import { REVIEW_RATING_BY_SITE_OPTIONS } from '../../../../constants';
import { useTranFormReviewRatingChartOption } from '../../../../hooks/useTranFormReviewRatingChartOption';
import get from 'lodash/get';
import { reviewRatingStyling } from './style';

const ReviewRatings = forwardRef((props, ref) => {
  const styles = reviewRatingStyling();
  const chart_options = {
    credits: {
      enabled: false
    },
    title: {
      text: ''
    },
    legend: {
      enabled: false
    },
    exporting: {
      enabled: false
    },
    chart: {
      width: 900,
      height: 400
    },
    xAxis: {
      categories: [],
      title: {
        text: ''
      }
    },
    yAxis: {
      title: {
        text: ''
      },
      min: 0
    },
    series: [
      {
        name: '',
        data: []
      }
    ],
    plotOptions: {
      series: {
        color: '#00008B'
      }
    }
  };
  const bar_chart_default_option = {
    exporting: {
      enabled: false
    },
    chart: {
      type: 'bar',
      margin: [50, 0, 50, 120]
    },
    title: {
      text: '',
      align: 'left'
    },
    xAxis: {
      categories: [],
      title: {
        text: 'Property',
        align: 'middle',
        offset: 110,
        rotation: -90,
        y: 0,
        style: {
          fontWeight: '600'
        }
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: ' ',
        align: 'middle',
        rotation: 0,
        offset: 0,
        y: 35
      }
    },
    legend: {
      reversed: true
    },
    plotOptions: {
      series: {
        stacking: 'normal',
        dataLabels: {
          enabled: true,
          align: 'left',
          fontSize: '40px',
          x: 5,
          inside: false,
          style: {
            color: 'black',
            fontWeight: 'bold',
            fontSize: '12px',
            textOutline: '1px contrast'
          }
        },
        minPointLength: 10,
        pointPadding: 0.1,
        groupPadding: 0.1,
        showInLegend: false
      }
    },
    series: [
      {
        data: [],
        color: '#5E68CB'
      }
    ],
    credits: {
      enabled: false
    }
  };
  const [selectedMetrix, setSelectedMetrix] = useState('% of Reviews');
  const { type, itemData, lowSampleSize } = props;
  const chartRef = useRef(null);

  const actionButtonClick = e => {
    handleHighChartsExport(e, chartRef, itemData);
  };
  useImperativeHandle(ref, () => ({ actionButtonClick }));

  const allowedClumns = ['Social Media Source', 'No of records', 'Overall Score', '% of Reviews', '#'];
  if (!itemData?.cstData) {
    return <GenericNoData />;
  }
  const tableData = convertCstDataIntoTableCompatibleTest(itemData?.cstData || {}, allowedClumns, "Social Media Source");
  const graphTableData = convertCstDataIntoTableCompatibleTest(itemData?.cstData || {}, null, "Social Media Source");
  // const data = itemData?.cstData || {};
  // const graphTableData = convertCstDataIntoTableCompatibleTest({ columns: data?.columns, metric_data: data?.metric_data, metric_count: data?.metric_count } || {});
  console.log(graphTableData)

  const isPercent = selectedMetrix === '% of Reviews';
  const chartOptions = useTranFormReviewRatingChartOption(
    bar_chart_default_option,
    isPercent ? '%' : '',
    selectedMetrix
  );
  const barChartData = convertCstDataIntoBarChartCompatible(
    itemData?.cstData,
    chartOptions,
    selectedMetrix,
    'Social Media Source'
  );
  // todo: change this temp change
  barChartData.xAxis.categories = itemData.cstData.rows;
  const color = get(chart_options, 'plotOptions.series.color', '#00008B');

  function renderContent() {
    switch (type) {
      case 'BAR':
        return (
          <>
            <Typography
              textProps={{ style: { marginBottom: 5 } }}
              variant='button'
              color='primaryContentMedium'
              fontWeightType='regular'>
              Question
            </Typography>

            <View style={{ maxWidth: 200 }}>
              <Dropdown
                items={REVIEW_RATING_BY_SITE_OPTIONS}
                onChange={setSelectedMetrix}
                value={selectedMetrix}
                label={''}
                style={{
                  container: {
                    ...dropdownStyling.container
                  },
                  optionContainer: dropdownStyling.optionContainer,
                  dropDownText: dropdownStyling.dropDownText,
                  icon: dropdownStyling.icon
                }}
              />
            </View>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={barChartData} />
            <View style={{ flexDirection: 'row', marginTop: 20 }}>
              <View style={{ flexDirection: 'row' }}>
                <View style={[styles.selectedMetrixContainer, { borderColor: color }]}>
                  <View style={{ width: 10, height: 10, backgroundColor: color }}></View>
                  <Typography fontWeightType='regular' variant='button'>
                    {selectedMetrix}
                  </Typography>
                </View>
              </View>
            </View>
          </>
        );
      case 'TIME':
        const finalData = {
          ...graphTableData,
          table_rows: graphTableData?.table_rows?.map(row => {
            const monthData = getMonthWithValues(row);

            console.log(row)
            const options = {
              ...chart_options,
              xAxis: {
                ...chart_options.xAxis,
                categories: monthData.months
              },
              series: chart_options.series.map((s, i) => ({
                ...s,
                data: i === 0 ? monthData.data : s.data
              }))
            };
            return {
              ...row,
              nested_row: []
              // nested_rows: [
              //   {
              //     [graphTableData?.table_columns?.[0]?.field]: {
              //       chart_options: options
              //     }
              //   }
              // ]
            };
          })
        };
        return <GraphTable graph_table_data={{ table_data: finalData }} />;
      case 'TABLE':
        return (
          <View style={{ height: 'auto' }}>
            <Table table_data={tableData} lowSampleSize={lowSampleSize} expendable={false} />
          </View>
        );
    }
  }

  return <View>{renderContent()}</View>;
});

export default ReviewRatings;
